export default ({driver: {address_street1 = ''} = {}} = {}) => address_street1;
